const RevokeConnectionModal = ({
  organizationName,
  provider = "xero",
}) => {
  const brand = provider === "qbo" ? "QuickBooks Online" : "Xero";

  return (
    <div className="py-8 text-gray-500 text-sm border-b border-gray-300">
      <div>
        Are you sure you want to disconnect this organization from {brand}?
        {organizationName ? (
          <b className="ml-2">{organizationName}</b>
        ) : null}
      </div>
      <div className="mt-6">
        This will revoke your <strong>{brand}</strong> connection and stop
        automatic backups. Existing backups will be removed after the retention
        period (you will receive warning emails before deletion).
      </div>
      <div className="mt-4 text-gray-600">
        To keep your backups long-term without live backups, use{" "}
        <strong>Downgrade to Vault</strong> instead.
      </div>
    </div>
  );
};

export default RevokeConnectionModal;
